import { PlaceCreate, PlaceRemove, PlaceUpdateDto } from '../../apis/place/PlaceCreate';
import { PlaceDetail, PlaceDetailFull, PlaceFind, PlaceSearch } from '../../apis/place/PlaceSearch';
import { PlaceRegister } from '../../interfaces/PlaceRegister';
import { PlaceUpdate } from '../../interfaces/PlaceUpdate';
import httpClient from '../../apis/base/httpClient';

export const PlaceService = {
  detail: async (placeId: number) => {
    return await PlaceDetail(placeId);
  },
  detailFull: async (placeId: number) => {
    return await PlaceDetailFull(placeId);
  },
  search: async (data: FilterParamsDto | null) => {
    return await PlaceSearch(data);
  },
  create: async (data: PlaceRegister, promotionalCode?: string) => {
    return await PlaceCreate(data, promotionalCode);
  },
  findAll: async () => {
    return await PlaceFind();
  },
  remove: async (placeId: number) => {
    return await PlaceRemove(placeId);
  },
  update: async (data: PlaceUpdate) => {
    return await PlaceUpdateDto(data);
  },
  verifyCNPJ: async (enterpriseNumber: string) => {
    const response = await httpClient.get(`/place/verify/${enterpriseNumber}`, { skipAuth: true });
    return response.data;
  },
};
